import React from "react";
import * as Icons from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Reveal";

const DEFAULT_CARDS = [
  { icon: "Target", t: "Strategic Sourcing", d: "We search against defined requirements rather than simply presenting available inventory." },
  { icon: "Gem", t: "Curated Opportunities", d: "Focus on relevance and commercial fit rather than volume." },
  { icon: "Globe2", t: "Multi-Market Access", d: "Source across selected domestic and international markets." },
  { icon: "ShieldCheck", t: "Confidentiality", d: "Sensitive opportunities and counterparties are handled discreetly." },
  { icon: "FileSignature", t: "Bespoke Mandates", d: "Investor and business requirements can be sourced individually." },
  { icon: "Scale", t: "Commercial Focus", d: "Opportunities are considered through the lens of value, terms, risk and strategic fit." },
];

export default function WhyGoldstone({ content }) {
  const eyebrow = content?.eyebrow || "Why Goldstone Sourcing";
  const heading = content?.heading || "A sourcing house, not a listings board.";
  const items = content?.cards?.length ? content.cards : DEFAULT_CARDS;

  return (
    <section data-testid="why-goldstone" className="bg-obsidian px-6 py-24 lg:px-10">
      <div className="mx-auto max-w-7xl">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h2 className="mt-5 max-w-2xl font-serif text-3xl leading-tight text-warmwhite lg:text-5xl">{heading}</h2>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((it, i) => {
            const Icon = Icons[it.icon] || Icons.Diamond;
            return (
              <Reveal key={i} delay={i * 0.05}>
                <div className="group h-full border border-gold/15 bg-obsidian p-8 transition-all duration-500 hover:-translate-y-1 hover:border-gold/40" data-testid={`why-card-${i}`}>
                  <Icon size={24} className="text-gold" strokeWidth={1.3} />
                  <h3 className="mt-6 font-serif text-xl text-warmwhite">{it.t}</h3>
                  <p className="mt-3 font-sans text-sm leading-relaxed text-softgrey">{it.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
